import { style } from 'typestyle'
export const t8 = style({ top: '8px' })
